<template functional>
  <div class="v2_info-popup__body px-2">
    <ul class="list-style-disc pl-3">
      <li>Review participation data for your specialty peers.</li>
      <li>
        Review crowdsourced data and key specialty measures (e.g., compensation,
        wRVUs).
      </li>
      <li>Review job market activity in your specialty.</li>
      <li>
        Review and manage your portfolio of Ideal Career Opportunity profiles.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DashboardInfoPopupContent',
};
</script>

<style scoped lang="scss">
.v2_info-popup__body {
  ul {
    list-style-type: none;
    padding: 0;
  }
}
</style>
